import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Typography,
  Flex,
  message,
  Select,
  Radio,
  Spin,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const ResetModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false); 
  const [openLoading, setOpenLoading] = useState(false);
  const [showParent, setShowParent] = useState(false);
  const [parentList, setParentList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);

  const signOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  /** 加载 parent list */
  const loadParentList = async () => {
    const res = await http.get(api.getGlTransRulesList);
    const data = (res.data || []).map((item) => ({
      value: item.id,
      label: item.name,
    }));
    setParentList(data);
  };
   const loadModuleList = async () => {
    try {
      const response = await http.get(api.getGLByModuleList);
      const data = (response.data.data || []).map((item) => ({
        value: item.moduleValue,
        label: item.module,
      }));
      setModuleList(data);
    } catch (err) {
      console.error("Failed :", err);
    }
  };
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      setCurrentRecord(null);
      form.resetFields();
      setShowParent(false); 
      setVisible(true);

      setOpenLoading(true);
      await loadParentList();
      await loadModuleList();
      setOpenLoading(false);

      form.setFieldsValue({
        level: "level1", // 默认 Level1
        sign: 0,
      });
    },

    open: async (record) => {
      setCurrentRecord(record);
      setVisible(true);
      setOpenLoading(true);

      form.resetFields();

      await loadParentList();
      await loadModuleList();
      setShowParent(record.parentId !== null);

      form.setFieldsValue({
        name: record.name,
        code: record.code,
        sign: record.sign,
        level: record.parentId ? "level2" : "level1",
        parentId: record.parentId || null,
        rules:record.rules,
        module:record.module
      });

      setOpenLoading(false);
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const queryParams = {
        id: currentRecord?.id ?? null,
        name: values.name,
        code: values.code || "",
        parentId: values.level === "level2" ? values.parentId : null,
        rules: values.rules || "",
        sign: values.sign ?? 0,
         module:values.module
      };

      const res = await http.post(api.getGlTransRulesUpload, queryParams);
      const r = res?.data || res;

      if (String(r.code) === "1") {
        message.success("Gl Trans Rules saved successfully");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(r?.msg || "Failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
            <Flex justify="flex-start" align="flex-start" className="model_title">
              <EditOutlined className="model_title_mr10" />
              <Typography.Title level={4} className="mg">
               GL TRANS RULES
              </Typography.Title>
            </Flex>
          }
      width="60%"
      open={visible}
      maskClosable={false}
      confirmLoading={openLoading}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>

        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Spin spinning={openLoading}>
              <Form
                form={form}
                name="glTransRulesForm"
                labelCol={{ style: { width: "180px" } }}
                wrapperCol={{ style: { flex: 1 } }}
                onFinish={onFinish}
              >
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Please enter a name" }]}
                >
                  <Input placeholder="Enter name" allowClear />
                </Form.Item>

                <Form.Item
                  name="code"
                  label="Code"
                  rules={[{ required: true, message: "Please enter a code" }]}
                >
                  <Input placeholder="Enter code" allowClear />
                </Form.Item>

                <Form.Item
                  name="sign"
                  label="Is Expense"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Select expense flag"
                    options={signOptions}
                    allowClear
                    showSearch
                  />
                </Form.Item>
                 <Form.Item
                    name="module"
                    label="Module"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Module"
                      options={moduleList}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                {/* <Form.Item
                  name="level"
                  label="Level"
                  rules={[{ required: true }]}
                >
                  <Radio.Group
                    onChange={(e) => setShowParent(e.target.value === "level2")}
                  >
                    <Radio value="level1">Level 1</Radio>
                    <Radio value="level2">Level 2</Radio>
                  </Radio.Group>
                </Form.Item> */}

                {showParent && (
                  <Form.Item
                    name="parentId"
                    label="Parent Type"
                    rules={[
                      { required: true, message: "Please select parent type" },
                    ]}
                  >
                    <Select
                      placeholder="Select parent"
                      options={parentList}
                      allowClear
                      showSearch
                    />
                  </Form.Item>
                )}

                <Form.Item name="rules" label="Rules">
                  <TextArea />
                </Form.Item>
              </Form>
            </Spin>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default ResetModal;
